// extracted by mini-css-extract-plugin
module.exports = {"page":"page--L9b3L","frame":"frame--hgDBU","box":"box--E7-LR","image":"image--eYpG-","info":"info--zPC7X"};